import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/vercel/path0/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/vercel/path0/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import chunk_reload_immediate_client_xfI97IMoyr from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload-immediate.client.js";
import plugin_vue3_A0OWXRrUgq from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/vercel/path0/.nuxt/pwa-icons-plugin.ts";
import pwa_client_ZuYw5i1i7i from "/vercel/path0/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_hBLWEPkA3b from "/vercel/path0/node_modules/@storyblok/nuxt/dist/runtime/plugin.js";
import chunk_error_handler_client_ErLKz4QKFy from "/vercel/path0/plugins/chunk-error-handler.client.ts";
import directives_8CcCirWtnE from "/vercel/path0/plugins/directives.ts";
import growthbook_client_4iB3FvliSu from "/vercel/path0/plugins/growthbook.client.ts";
import gtm_client_OzmBuHLRIb from "/vercel/path0/plugins/gtm.client.ts";
import helpers_mgWmzbOuLB from "/vercel/path0/plugins/helpers.ts";
import mixpanel_client_JbuVUz27YJ from "/vercel/path0/plugins/mixpanel.client.ts";
import recaptcha_85gNSCNFUU from "/vercel/path0/plugins/recaptcha.ts";
import sanitize_html_C43THMiKPl from "/vercel/path0/plugins/sanitize-html.ts";
import screen_G46wZg10vP from "/vercel/path0/plugins/screen.ts";
import sentry_client_shVUlIjFLk from "/vercel/path0/plugins/sentry.client.ts";
import vue_lazyload_ZuGxV4v2Qq from "/vercel/path0/plugins/vue-lazyload.ts";
export default [
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  chunk_reload_immediate_client_xfI97IMoyr,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_ZuYw5i1i7i,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_hBLWEPkA3b,
  chunk_error_handler_client_ErLKz4QKFy,
  directives_8CcCirWtnE,
  growthbook_client_4iB3FvliSu,
  gtm_client_OzmBuHLRIb,
  helpers_mgWmzbOuLB,
  mixpanel_client_JbuVUz27YJ,
  recaptcha_85gNSCNFUU,
  sanitize_html_C43THMiKPl,
  screen_G46wZg10vP,
  sentry_client_shVUlIjFLk,
  vue_lazyload_ZuGxV4v2Qq
]